// @flow
import React from 'react';

import { createRefetchContainer, graphql } from 'react-relay';

import { withRouter } from 'react-router-dom';
// material
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/svg-icons/navigation/menu';
import { Helmet } from 'react-helmet';

import { removeToken } from './lib/LoginUtils';
// style
import './components/ui/sidebar-menu.css';
import './App.css';
import { withSiteMap } from './util/with-site-map';
import { SidebarMenu } from './components/sidebar-menu/sidebar-menu';
import UserInfo from './components/userInfo/UserInfo';

const setPageTitle = path => {
	const pageTitle = {
		articles: {
			default: 'Новости и Статьи',
			'U2VjdGlvbjo1OTg4YmM3MTNhODdiYzUyMDMwMzUyMzQ=': 'Новости',
			'U2VjdGlvbjo1OTg4YmNiNzA2YmFlMjUyNzU3NmJhMWI=': 'Статьи',
		},
		shows: {
			default: 'Список программ',
			new: 'Создание программы',
		},
		people: {
			default: 'Люди',
		},
		person: {
			default: 'Персона — редактирование',
		},
		new_person: {
			default: 'Создание персоны',
		},
		topics: {
			default: 'Темы',
		},
		topic: {
			default: 'Редактирование темы',
		},
		categories: {
			default: 'Рубрики',
		},
		category: {
			default: 'Редактирование рубрики',
		},
		epg: {
			default: 'ТВ-Программа',
			new: 'Добавление передачи',
		},
		streams: {
			default: 'Стримы',
		},
		stream: {
			default: 'Стрим',
		},
		video: {
			default: 'Медиа-галерея',
		},
		stats: {
			default: 'Статистика',
		},
		background: {
			default: 'Фон сайта',
		},
	};
	const arr = path.split('/');
	let title = `${withSiteMap('{SITE_MAP}78.ru', process.env.SITEMAP)}.админка`;
	arr.shift();
	const rootElement = arr[0];
	const childElement = arr[arr.length - 1];

	if ({}.hasOwnProperty.call(pageTitle, rootElement)) {
		if ({}.hasOwnProperty.call(pageTitle[rootElement], childElement)) {
			title = pageTitle[rootElement][childElement];
		} else {
			title = pageTitle[rootElement].default;
		}
	}
	return title;
};

type Props = {
	viewer: Object,
	relay: Object,
	location: Object,
	children: any,
	history: Array<string>,
};
type State = {
	userInfo: ?Object,
};

class App extends React.Component<Props, State> {
	state = {
		userInfo: this.props.viewer.me,
	};

	componentWillReceiveProps(nextProps: Props, nextContext) {
		this.setState({ userInfo: nextProps.viewer.me });
	}

	onLogoutPressed = () => {
		removeToken();
		this.setState({ userInfo: {} });
	};

	handleLogoClick = () => {
		this.props.history.push('/');
	};

	render() {
		const pathname = this.props.location != null ? this.props.location.pathname : '';

		// adjust for left drawer and top, with a standard padding
		// for non fixed elements.
		const appbarHeight = 64;
		const drawerWidth = 240;
		const pad = 30;

		// this will be padding (or fixed positions) depending on whethere drawer is open
		const left = drawerWidth;
		const width = `calc(100% - ${drawerWidth + 2 * pad}px)`;

		// each child will be enclosed in this style

		const contentStyle = {
			minHeight: `calc(100vh - ${pad * 3 + appbarHeight})`,
			width,
			maxWidth: width,
			marginTop: 0,
			marginLeft: left + pad,
			marginBottom: 0,
			marginRight: pad,
			paddingTop: pad + appbarHeight,
			backgroundColor: '#edecec',
		};

		return (
			<div style={{ minHeight: '100vh', backgroundColor: '#edecec' }}>
				<SidebarMenu pathname={pathname} drawerWidth={drawerWidth}>
					<UserInfo info={this.state.userInfo} onLogout={this.onLogoutPressed} relay={this.props.relay} history={this.props.history} />
				</SidebarMenu>
				<AppBar
					style={{ position: 'fixed' }}
					title="78"
					iconElementLeft={
						<IconButton onClick={this.handleLogoClick}>
							<IconMenu />
						</IconButton>
					}
				/>

				<div style={contentStyle}>
					<Helmet>
						<title>
							{setPageTitle(pathname)} — {withSiteMap('{SITE_MAP}78.ru', process.env.SITEMAP)}.админка
						</title>
					</Helmet>
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		App,
		graphql`
			fragment App_viewer on Viewer {
				id
				me {
					id
					name
					email
					canDelete
				}
			}
		`,
		graphql`
			query AppRefectchQuery {
				viewer {
					...App_viewer
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/App.js